// biome-ignore lint: disable
import * as React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { MDXProvider } from '@mdx-js/react';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import { theme } from '../theme';
import { Fonts } from '../theme/global';
import { Layout } from './Layout';
import { AnchorHeading } from './SupportPage/AnchorHeading';

const STANDALONE_PATHS = ['/pricing-update'];

const mdxComponents = {
  h2: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
    <AnchorHeading as="h2" {...props} />
  ),
  h3: (props: React.HTMLAttributes<HTMLHeadingElement>) => (
    <AnchorHeading as="h3" {...props} />
  ),
};

export const wrapPageElement = ({
  element,
  props,
}: WrapPageElementBrowserArgs) => {
  const isStandalone = STANDALONE_PATHS.some((p) =>
    props.location.pathname.startsWith(p),
  );
  return (
    <ChakraProvider theme={theme} resetCSS>
      <Fonts />
      <MDXProvider components={mdxComponents}>
        {isStandalone ? element : <Layout>{element}</Layout>}
      </MDXProvider>
    </ChakraProvider>
  );
};
